import { Award } from "../../Api/Database"

export interface RegisterAwardProps {
    data: Award

    onChange: (data: Award) => void
    onRemove: () => void
}

export default function RegisterAward(props: RegisterAwardProps) {

    const onChange = (name: string, data: any) => {
        props.onChange({...props.data, [name]: data} as Award)
    }

    return (<>
        <div style={{border: "1px solid #cecece", padding:"10px",marginBottom:"20px"}}>
            
            <div>
                <label>  Title{" "} </label>
                <input type="text" className="issuer-form" name="title" maxLength={1000} placeholder="e.g., Malcolm Baldrige National Quality Award (MBNQA) " value={props.data.title} onChange={(event) => { onChange("title", event.target.value); }} ></input>
            </div>
            <div>
                <label>  Summary{" "} </label>
                <input type="text" className="issuer-form" name="title" maxLength={1000} placeholder="e.g., The Baldrige Criteria standards within the Criteria are co-created by quality experts, business executives, government experts." value={props.data.summary } onChange={(event) => { onChange("summary", event.target.value); }} ></input>
            </div>
            <div>
                <label>  Award Link{" "} </label>
                <input type="url" className="issuer-form" name="title" maxLength={1000} placeholder="e.g., https://www.example-award.com" value={props.data.url} onChange={(event) => { onChange("url", event.target.value); }} ></input>
            </div>
            <div>
                <label> Image{" "} </label>
                <input type="url" className="issuer-form" name="title" maxLength={1000} placeholder="e.g., https://www.example.com/logo.png" value={props.data.image } onChange={(event) => { onChange("image", event.target.value); }} ></input>
            </div>

            <div style={{height:"20px",marginTop:"10px"}}>
                <button type="button" className="form_btn" onClick={props.onRemove}>Remove </button>
            </div>
            
        </div>
    </>)
}